export function createCanvas() {
  if (!process.browser) {
    throw new Error(
      'Tried to create a canvas on server, this behavior is not yet defined',
    )
  }
  if (typeof OffscreenCanvas !== 'undefined') {
    return new OffscreenCanvas(2000, 2000).getContext('2d')
  } else {
    return document.createElement('canvas').getContext('2d')
  }
}
